import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import Spinner from '../../../../components/Spinner/';
import LoginHOC from '../../../../components/LoginHOC';

const CancelSession = gql`
mutation (
  $ModuleInstance: Int!
) {
  requestSessionCancelForm (ModuleInstanceID: $ModuleInstance) {
    id
    user_id
    module_instance_id
    module_component_id
  }
}
`;

class Redirect extends React.Component {
  state = {
    error: null,
  };

  componentDidMount() { // handle redirect
    console.log(this.props);
    this.props.CancelSession({
      variables: {
        ModuleInstance: parseInt(this.props.routeParams.ModuleInstance, 10),
      },
    }).then(FormData => {
      window.location = (document.location.origin + '/modules/component/' + FormData.data.requestSessionCancelForm.id + '/');
    }).catch(err => {
      console.log(err, JSON.stringify(err));
      this.setState({
        error: err.graphQLErrors[0].message,
      });
    })
  }

  render() {
    return (
      <div className='container'>
        <div className='page-layout__viewport'>
          {(this.state.error === null) ? <Spinner />
            : <p style={{ color: 'red', textAlign: 'center' }}>{this.state.error}</p>}
        </div>
      </div>
    );
  }
}

export default (store) => ({
  path: 'cancel/:ModuleInstance',
  component: LoginHOC(compose(
    graphql(CancelSession, {
      name: 'CancelSession',
      options: {
        fetchPolicy: 'network-only',
      },
    })(Redirect)
  )),
});


// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/CancelSession/index.js